import React from 'react';

import Error from '../../../pages/General/error';
import PageSpinner from '../../../pages/General/pageSpinner';

import { PageError } from '../../../types';

interface Props {
  children?: React.ReactNode;
  isLoading?: boolean;
  pageError?: PageError;
  noTips?: boolean;
}

const PageContent: React.FC<Props> = (props) => {
  const { children, isLoading, pageError, noTips } = props;

  if (isLoading) return <PageSpinner noTips={noTips} />;
  else if (!!pageError) return <Error code={pageError} />;
  else if (!!children) return <>{children}</>;
  else return <></>;
};

export default PageContent;
